// TODO: migrate to ./store.js
export default {
	startMeeting_errorMessage: "An error occurred while starting a meeting: {message}",
	stopMeeting_errorMessage: "An error occurred while stopping a meeting: {message}",
	joinMeeting_errorMessage: "An error occurred while joining a meeting: {message}",
	leaveMeeting_errorMessage: "An error occurred while leaving a meeting: {message}",
	saveMeetingNote_errorMessage: "An error occurred while saving a meeting note: {message}",
	startTopic_errorMessage: "An error occurred while starting a topic: {message}",
	createOutcome_errorMessage: "An error occurred while adding an outcome to a topic: {message}",
	updateOutcome_errorMessage: "An error occurred while updating a topic outcome: {message}",
	queueMeetingReport_errorMessage: "An error occurred while finalizing the meeting report: {message}",
	fetchMeetingNote_errorMessage: "An error occurred while fetching private notes for the meeting: {message}",
	saveNewOutcome_errorMessage: "An error occurred while saving the outcome: {message}",

	outcomeType_actionItem_title: "Action item",
	outcomeType_actionItem_subtitle: "(Default)",
	outcomeType_actionItem_description: "Record action or next step to be taken by whom",
	outcomeType_decision_title: "Decision",
	outcomeType_decision_description: "Record the decision that was made",
	outcomeType_summary_title: "Note",
	outcomeType_summary_description: "Summarize the discussion of this topic",
	outcomeType_conclusion_title: "Conclusion",
	outcomeType_conclusion_description: "Record a conclusion that was reached for this topic",
};



// WEBPACK FOOTER //
// ./src/lang/en/meetingStore.js